import { render, staticRenderFns } from "./FormTanggal.vue?vue&type=template&id=67d37064&"
import script from "./FormTanggal.vue?vue&type=script&lang=js&"
export * from "./FormTanggal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports